import React from 'react'

import {t} from '@lib/helpers'
import {
  architectureStepIcons,
  HOW_WE_WORK_CAPTION_HEIGHT,
  HOW_WE_WORK_CAPTION_WIDTH,
  howWeWorkCaption,
  html,
  zipWithImage,
} from './constant'

const Connector = () => (
  <svg
    className='PartnerAws__architecture__connector'
    viewBox='0 0 12 26'
    aria-hidden='true'
  >
    <path
      d='M6.27344 0.75L6.27344 3.27835e-08L4.77344 -3.27835e-08L4.77344 0.75L5.52344 0.75L6.27344 0.75ZM4.99311 25.2803C5.286 25.5732 5.76087 25.5732 6.05377 25.2803L10.8267 20.5074C11.1196 20.2145 11.1196 19.7396 10.8267 19.4467C10.5338 19.1538 10.059 19.1538 9.76608 19.4467L5.52344 23.6893L1.2808 19.4467C0.987903 19.1538 0.513029 19.1538 0.220136 19.4467C-0.0727576 19.7396 -0.0727576 20.2145 0.220136 20.5074L4.99311 25.2803ZM5.52344 0.75L4.77344 0.75L4.77344 24.75L5.52344 24.75L6.27344 24.75L6.27344 0.75L5.52344 0.75Z'
      fill='currentColor'
    />
  </svg>
)

export default function Architecture() {
  const steps = zipWithImage(
    t('pages.partnerAws.architecture.steps'),
    architectureStepIcons
  )

  return (
    <section className='PartnerAws__architecture'>
      <div className='PartnerAws__inner'>
        <div className='PartnerAws__architecture__card'>
          <div className='PartnerAws__architecture__text'>
            <img
              className='PartnerAws__architecture__caption'
              src={howWeWorkCaption}
              alt={t('pages.partnerAws.architecture.caption')}
              width={HOW_WE_WORK_CAPTION_WIDTH}
              height={HOW_WE_WORK_CAPTION_HEIGHT}
            />
            <h2 className='PartnerAws__section-title'>
              {t('pages.partnerAws.architecture.titleLine1')}
              <br />
              {t('pages.partnerAws.architecture.titleLine2')}
            </h2>
            <p
              className='PartnerAws__architecture__description'
              {...html(t('pages.partnerAws.architecture.description'))}
            />
          </div>

          <div className='PartnerAws__architecture__timeline'>
            {steps.map((step, index) => (
              <div className='PartnerAws__architecture__step' key={index}>
                {index > 0 && <Connector />}
                <div className='PartnerAws__architecture__row'>
                  <div className='PartnerAws__architecture__icon'>
                    {!!step.image && <img src={step.image} alt='' />}
                  </div>
                  <div className='PartnerAws__architecture__row__text'>
                    <h3 className='PartnerAws__architecture__step__title'>
                      {step.title}
                    </h3>
                    <p className='PartnerAws__architecture__step__description'>
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
